<template>
  <el-link
    type="primary"
    @click.stop="openLink"
  >
    <el-icon
      :name="loading ? 'loading' : 'view'"
    />
    {{ label }}
  </el-link>
</template>
<script>
export default {
  props: ['path', 'label'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async openLink() {
      this.loading = true;
      try {
        const url = await axios.get('api/files?path=' + this.path);
        window.open(url);
      } catch (e) {

      }
      this.loading = false;
    }
  },
};
</script>
